<template>
	<inertia-head title="Attendees Checkin" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TKT EVENT</h1>
					<h2 class="h4 fw-normal text-white-75">Attendees Checkin</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">

		<div v-if="total_claim>0" class="row mb-5">
			<div class="col-12 text-center">
				<div class="mb-4">
					<span class="bg-info text-white h4 py-2 px-3">TOTAL OF ATTENDEES NOT YET CLAIMED: {{total_claim}}</span>
				</div>
				<div v-if="claim_by_data!==null">
					<button v-if="claim_by_data.total_not_called==0" @click="claimAttendee()" :disabled="formClaim.processing" type="button" class="btn btn-lg btn-success">
						<div
							v-if="formClaim.processing"
							class="spinner-border spinner-border-sm text-white me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<span>
							Claim 15 Attendees
						</span>
					</button>
				</div>
			</div>
		</div>

		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<span class="input-group-text">Status</span>
						<select v-model="form.filter" name="filter" class="form-select">
							<option value="">All</option>
							<option value="pending">Pending</option>
							<option value="joined">Joined</option>
							<option value="followup">For Follow-up</option>
							<option value="will join next time">Will join next time</option>
							<option value="call not answered">Call not answered</option>
							<option value="number incorrect">Number incorrect</option>
							<option value="international number">International Number</option>
							<option value="requested for callback">Requested for callback</option>
						</select>
					</div>
				</div>
				<div class="block-options">
					<div class="input-group">
						<input v-model="form.search" type="text" name="search" class="form-control" placeholder="Search" />
						<span class="input-group-btn ms-1">
							<button type="button" @click="fetchAttendees" :disabled="formSearch.processing" class="btn btn-info">
								<div
									v-if="formSearch.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-search me-1"></i>
								Search
							</button>
						</span>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div>
					<span class="badge bg-info me-1">TOTAL CLAIM: {{claim_by_data.total_claim || 0}}</span>
					<span class="badge bg-success me-1">TOTAL CALLED: {{claim_by_data.total_called || 0}}</span>
					<span class="badge bg-danger">TOTAL NOT CALLED: {{claim_by_data.total_not_called || 0}}</span>
				</div>
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>Event Info</th>
								<th>Attendee Info</th>
								<th>Contact#</th>
								<th>Member?</th>
								<th>Checkin Date</th>
								<th>Status</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(attendee, c_index) in checkins.data"
								:key="attendee.attendee_checkin_uuid"
							>
								<td>
									{{attendee.event_title}}
									<div><sub class="text-muted">{{attendee.date_start}} {{attendee.time_start}} - {{attendee.date_end}} {{attendee.time_end}}</sub></div>
								</td>
								<td>
									{{attendee.first_name}} {{attendee.last_name}}
									<div><sub class="text-info">{{attendee.email_address}}</sub></div>
								</td>
								<td><span v-if="attendee.contact_country!==null" class="badge bg-info">{{attendee.contact_country}} +{{attendee.country_calling_code}}</span>{{attendee.contactno}}</td>
								<td>
									<span v-if="attendee.is_member>0" class="badge bg-success">YES</span>
									<span v-else class="badge bg-danger">NO</span>
								</td>
								<td>{{attendee.checkin_date}}</td>
								<td>
									<span class="badge" :class="{'bg-success':attendee.status=='Joined','bg-danger':attendee.status=='Pending'}">{{attendee.status}}</span>
									<div v-if="attendee.status=='Pending'"><sub>{{attendee.followup_status}}</sub></div>
								</td>
								<td nowrap="" class="text-end">
									<!-- <button @click="viewStockDetails(c_index)" type="button" class="btn btn-sm btn-alt-success me-1" title="View Stock Details"><i class="fa fa-search"></i></button> -->
									<button @click="viewFollowupContentModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info" title="Follow Up"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="checkins.data.length <= 0">
								<td colspan="8" class="mb-0 fw-semibold text-center p-5">NO ATTENDEES FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="checkins.data.length > 0" :collections="checkins"/>
			</div>
		</div>
		<TktAttendeeFollowUp ref="tktAttendeeFollowUpModal" />
	</div>
</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';

	import TktAttendeeFollowUp from '../../Components/Admin/TktAttendeeFollowUp'

	export default{
		layout: AuthLayout,
		props: {
			total_claim				: Number,
			claim_by_data			: Object,
			checkins				: Object,
			filter					: String,
			search					: String,
			api_response 			: Object
		},
		components:{TktAttendeeFollowUp},
		setup(props){

			const tktAttendeeFollowUpModal = ref();

			const action 	= ref('claim');
			const toast 	= createToaster();

			const selectedFollowupContent = reactive({});

			const form = useForm({
							filter 	: props.filter,
							search 	: props.search,
						})

			const formSearch = useForm({});
			const formClaim = useForm({});

			const fetchAttendees = () => {
											formSearch.get(route('admin.tkt-attendees-checkin',{
													filter 	: form.filter,
													search 	: form.search
												}),
												{
													preserveState: true,
													preserveScroll: true,
													only: ['total_claim','claim_by_data','checkins','filter','search','api_response'],
													onSuccess: () => {}
												}
											)
										}


			const viewFollowupContentModal = (_index,_action)=>{
			
				action.value = _action;
				
				if(_action=='update')
				{
					selectedFollowupContent.tkt_attendee_list_uuid 			= props.checkins.data[_index].tkt_attendee_list_uuid;
					selectedFollowupContent.event_title 					= props.checkins.data[_index].event_title;
					selectedFollowupContent.checkin_date 					= props.checkins.data[_index].checkin_date;
					selectedFollowupContent.first_name 						= props.checkins.data[_index].first_name;
					selectedFollowupContent.last_name 						= props.checkins.data[_index].last_name;
					selectedFollowupContent.email_address 					= props.checkins.data[_index].email_address;
					selectedFollowupContent.contactno 						= props.checkins.data[_index].contactno;
					selectedFollowupContent.country_calling_code 			= props.checkins.data[_index].country_calling_code;
					selectedFollowupContent.network_carrier 				= props.checkins.data[_index].network_carrier;
					selectedFollowupContent.contact_country 				= props.checkins.data[_index].contact_country;
					selectedFollowupContent.is_member 						= props.checkins.data[_index].is_member;
					selectedFollowupContent.status 							= props.checkins.data[_index].status;


				}

				tktAttendeeFollowUpModal.value.setFollowupContent(selectedFollowupContent);

				tktAttendeeFollowUpModal.value.toggleModal();

			}


			const claimAttendee =()=>{

				action.value = 'claim';
				formClaim.post(route('admin.post.tkt-attendees-claim'), {}, {
							preserveState: true,
							preserveScroll: true,
							only: ['total_claim','claim_by_data','checkins','filter','search','api_response'],
							onSuccess: () => {}
						})

			}

			watch(()=>props.api_response, (value) => {
			
				if(value!=null)
				{
					if(value.result=="success")
					{	
						toast.show("Successfully saved", { type: value.result});
					}else
					{
						if(action.value=='claim')
						{
							toast.show("No more attendees to claim", { type: "error"});
						}else 
						{
							toast.show("Failed to save", { type: "error"});
						}
					}
				}
			})

			return{
				toast,
				form,
				formSearch,
				formClaim,
				action,
				tktAttendeeFollowUpModal,
				viewFollowupContentModal,
				selectedFollowupContent,
				fetchAttendees,
				claimAttendee
			}
		}
	}

</script>